// extracted by mini-css-extract-plugin
module.exports = {"container":"header-wrapper_container__MKXqa","fix-layer":"header-wrapper_fix-layer__fna9a","scrolled":"header-wrapper_scrolled__DuUVf"};